/* eslint-disable no-unused-vars */
import React from "react";

// eslint-disable-next-line react/prop-types
function CrossIcon({ width = 12, height = 12 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8337 1.33268L10.667 0.166016L6.00033 4.83268L1.33366 0.166016L0.166992 1.33268L4.83366 5.99935L0.166992 10.666L1.33366 11.8327L6.00033 7.16602L10.667 11.8327L11.8337 10.666L7.16699 5.99935L11.8337 1.33268Z"
        fill="#616161"
        fillOpacity="0.5"
      />
    </svg>
  );
}

export default CrossIcon;
